<template>
  <div :class='$style.container'>
    <i :class='$style.num'>{{num}}</i>
    <div :class='$style.title'>
      {{title}}
      <span :class='$style.time' v-if='time'>更新时间：{{time}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    num: String,
    title: String,
    time: String
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and(max-width:750px) {
  .title {
    font-size: rem(24) !important;
  }
  .num {
    font-size: rem(15) !important;
  }
}
.container {
  color: #371f1f;
}
.num {
  font-size: 18px;
}
.title {
  position: relative;
  font-size: 32px;
  font-weight: 700;
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    width: 72px;
    border-bottom: 3px solid #d8c39f;
  }
}
.time {
  margin-left: 6px;
  font-size: 16px;
  font-weight: 400;
}
</style>